// Module
var code = "<template class=\"mooring-components-tab\">\n  <require from=\"./buoys-container\"></require>\n  <buoys-container if.bind=\"data.productionOrderId > 0\" production-order-id.bind=\"data.productionOrderId\"></buoys-container>\n</template>\n";
// Exports
export default code;